import { uniq } from 'lodash';
const menus = [
  {
    menuId: 68,
    status: 1,
    parentId: -1,
    menuName: '营销能力矩阵',
    menus: [],
  },
  {
    menuId: 67,
    status: 1,
    parentId: 4,
    menuName: '活动效果数据',
    menus: [],
  },
  {
    menuId: 65,
    status: 1,
    parentId: -1,
    menuName: '平台营销阵地',
    menus: [],
  },
  {
    menuId: 64,
    status: 1,
    parentId: 4,
    menuName: '提报运营数据',
    menus: [],
  },
  {
    menuId: 63,
    status: 1,
    parentId: 5,
    menuName: '频道管理',
    menus: [],
  },
  {
    menuId: 62,
    status: 1,
    parentId: 5,
    menuName: '白名单管理',
    menus: [],
  },
  {
    menuId: 61,
    status: 1,
    parentId: 4,
    menuName: '会场流程数据',
    menus: [],
  },
  {
    menuId: 60,
    status: 1,
    parentId: 4,
    menuName: '用户资产沉淀',
    menus: [],
  },
  {
    menuId: 59,
    status: 1,
    parentId: 57,
    menuName: '已报名素材',
    menus: [],
  },
  {
    menuId: 58,
    status: 1,
    parentId: 57,
    menuName: '待审核素材',
    menus: [],
  },
  {
    menuId: 57,
    status: 1,
    parentId: -1,
    menuName: '事项总览',
    menus: [
      {
        menuId: 59,
        status: 1,
        parentId: 57,
        menuName: '已报名素材',
        menus: [],
      },
      {
        menuId: 58,
        status: 1,
        parentId: 57,
        menuName: '待审核素材',
        menus: [],
      },
      {
        menuId: 75,
        status: 1,
        parentId: 57,
        menuName: '活动报名',
        menus: [],
      },
    ],
  },
  {
    menuId: 56,
    status: 1,
    parentId: -1,
    menuName: '盘货工具',
    menus: [],
  },
  {
    menuId: 55,
    status: 1,
    parentId: 53,
    menuName: '综促活动',
    menus: [],
  },
  {
    menuId: 54,
    status: 1,
    parentId: 53,
    menuName: '会场活动',
    menus: [],
  },
  {
    menuId: 53,
    status: 1,
    parentId: -1,
    menuName: '日常活动',
    menus: [
      {
        menuId: 55,
        status: 1,
        parentId: 53,
        menuName: '综促活动',
        menus: [],
      },
      {
        menuId: 54,
        status: 1,
        parentId: 53,
        menuName: '会场活动',
        menus: [],
      },
    ],
  },
  {
    menuId: 52,
    status: 1,
    parentId: 4,
    menuName: '活动进度监控',
    menus: [],
  },
  {
    menuId: 51,
    status: 1,
    parentId: 46,
    menuName: '权限管理',
    menus: [],
  },
  {
    menuId: 49,
    status: 1,
    parentId: 46,
    menuName: '趋势管理',
    menus: [],
  },
  {
    menuId: 48,
    status: 1,
    parentId: 5,
    menuName: '满意度调研配置',
    menus: [],
  },
  {
    menuId: 47,
    status: 1,
    parentId: 5,
    menuName: '营销TREE配置',
    menus: [],
  },
  {
    menuId: 46,
    status: 1,
    parentId: -1,
    menuName: '趋势运营',
    menus: [
      {
        menuId: 51,
        status: 1,
        parentId: 46,
        menuName: '权限管理',
        menus: [],
      },
      {
        menuId: 49,
        status: 1,
        parentId: 46,
        menuName: '趋势管理',
        menus: [],
      },
      {
        menuId: 79,
        status: 1,
        parentId: 46,
        menuName: '趋势数据',
        menus: [],
      },
      {
        menuId: 80,
        status: 1,
        parentId: 46,
        menuName: '热点营销',
        menus: [],
      },
      {
        menuId: 81,
        status: 1,
        parentId: 46,
        menuName: '营销词洞察',
        menus: [],
      },
    ],
  },
  {
    menuId: 45,
    status: 1,
    parentId: 5,
    menuName: '工作台资源位配置',
    menus: [],
  },
  {
    menuId: 44,
    status: 1,
    parentId: 5,
    menuName: '商家阵地管理',
    menus: [],
  },
  {
    menuId: 43,
    status: 1,
    parentId: 39,
    menuName: '自动化素材',
    menus: [],
  },
  {
    menuId: 42,
    status: 1,
    parentId: 39,
    menuName: '潘多拉',
    menus: [],
  },
  {
    menuId: 41,
    status: 1,
    parentId: 39,
    menuName: '广告组',
    menus: [],
  },
  {
    menuId: 40,
    status: 1,
    parentId: 39,
    menuName: '商品组',
    menus: [],
  },
  {
    menuId: 39,
    status: 1,
    parentId: -1,
    menuName: '素材管理',
    menus: [
      {
        menuId: 43,
        status: 1,
        parentId: 39,
        menuName: '自动化素材',
        menus: [],
      },
      {
        menuId: 42,
        status: 1,
        parentId: 39,
        menuName: '潘多拉',
        menus: [],
      },
      {
        menuId: 41,
        status: 1,
        parentId: 39,
        menuName: '广告组',
        menus: [],
      },
      {
        menuId: 40,
        status: 1,
        parentId: 39,
        menuName: '商品组',
        menus: [],
      },
    ],
  },
  {
    menuId: 38,
    status: 1,
    parentId: 5,
    menuName: '商家端帮助中心',
    menus: [],
  },
  {
    menuId: 37,
    status: 1,
    parentId: 3,
    menuName: '活动数据',
    menus: [],
  },
  {
    menuId: 36,
    status: 1,
    parentId: 3,
    menuName: '申请列表',
    menus: [],
  },
  {
    menuId: 35,
    status: 1,
    parentId: -1,
    menuName: '行业频道',
    menus: [],
  },
  {
    menuId: 34,
    status: 1,
    parentId: 33,
    menuName: 'banner管理',
    menus: [],
  },
  {
    menuId: 33,
    status: 1,
    parentId: 5,
    menuName: '运营位配置',
    menus: [
      {
        menuId: 34,
        status: 1,
        parentId: 33,
        menuName: 'banner管理',
        menus: [],
      },
    ],
  },
  {
    menuId: 32,
    status: 1,
    parentId: -1,
    menuName: '分析报告',
    menus: [],
  },
  {
    menuId: 31,
    status: 1,
    parentId: 5,
    menuName: '公告管理',
    menus: [],
  },
  {
    menuId: 29,
    status: 1,
    parentId: 10,
    menuName: '日常活动',
    menus: [],
  },
  {
    menuId: 28,
    status: 1,
    parentId: 5,
    menuName: '帮助中心管理',
    menus: [],
  },
  {
    menuId: 27,
    status: 1,
    parentId: 4,
    menuName: '资源位数据',
    menus: [],
  },
  {
    menuId: 25,
    status: 1,
    parentId: -1,
    menuName: '工作台',
    menus: [],
  },
  {
    menuId: 24,
    status: 1,
    parentId: 3,
    menuName: '资源位列表',
    menus: [],
  },
  {
    menuId: 23,
    status: 1,
    parentId: 3,
    menuName: '资源列表',
    menus: [],
  },
  {
    menuId: 20,
    status: 1,
    parentId: 15,
    menuName: '数据对比',
    menus: [],
  },
  {
    menuId: 19,
    status: 1,
    parentId: 15,
    menuName: '活动选择',
    menus: [],
  },
  {
    menuId: 18,
    status: 1,
    parentId: -1,
    menuName: '用户画像',
    menus: [],
  },
  {
    menuId: 17,
    status: 1,
    parentId: -1,
    menuName: '商品效果',
    menus: [],
  },
  {
    menuId: 16,
    status: 1,
    parentId: -1,
    menuName: '活动数据',
    menus: [],
  },
  {
    menuId: 15,
    status: 1,
    parentId: 4,
    menuName: '活动对比',
    menus: [
      {
        menuId: 20,
        status: 1,
        parentId: 15,
        menuName: '数据对比',
        menus: [],
      },
      {
        menuId: 19,
        status: 1,
        parentId: 15,
        menuName: '活动选择',
        menus: [],
      },
    ],
  },
  {
    menuId: 13,
    status: 1,
    parentId: 3,
    menuName: '资源调剂',
    menus: [],
  },
  {
    menuId: 12,
    status: 1,
    parentId: 3,
    menuName: '申请管理',
    menus: [],
  },
  {
    menuId: 11,
    status: 1,
    parentId: 10,
    menuName: '主题活动',
    menus: [],
  },
  {
    menuId: 10,
    status: 1,
    parentId: -1,
    menuName: '活动管理',
    menus: [
      {
        menuId: 29,
        status: 1,
        parentId: 10,
        menuName: '日常活动',
        menus: [],
      },
      {
        menuId: 11,
        status: 1,
        parentId: 10,
        menuName: '主题活动',
        menus: [],
      },
    ],
  },
  {
    menuId: 9,
    status: 1,
    parentId: 6,
    menuName: '人员管理',
    menus: [],
  },
  {
    menuId: 8,
    status: 1,
    parentId: 6,
    menuName: '角色组管理',
    menus: [],
  },
  {
    menuId: 7,
    status: 1,
    parentId: 5,
    menuName: '流程配置',
    menus: [],
  },
  {
    menuId: 6,
    status: 1,
    parentId: 5,
    menuName: '权限管理',
    menus: [
      {
        menuId: 9,
        status: 1,
        parentId: 6,
        menuName: '人员管理',
        menus: [],
      },
      {
        menuId: 8,
        status: 1,
        parentId: 6,
        menuName: '角色组管理',
        menus: [],
      },
    ],
  },
  {
    menuId: 5,
    status: 1,
    parentId: -1,
    menuName: '系统设置',
    menus: [
      {
        menuId: 63,
        status: 1,
        parentId: 5,
        menuName: '频道管理',
        menus: [],
      },
      {
        menuId: 62,
        status: 1,
        parentId: 5,
        menuName: '白名单管理',
        menus: [],
      },
      {
        menuId: 48,
        status: 1,
        parentId: 5,
        menuName: '满意度调研配置',
        menus: [],
      },
      {
        menuId: 47,
        status: 1,
        parentId: 5,
        menuName: '营销TREE配置',
        menus: [],
      },
      {
        menuId: 45,
        status: 1,
        parentId: 5,
        menuName: '工作台资源位配置',
        menus: [],
      },
      {
        menuId: 44,
        status: 1,
        parentId: 5,
        menuName: '商家阵地管理',
        menus: [],
      },
      {
        menuId: 38,
        status: 1,
        parentId: 5,
        menuName: '商家端帮助中心',
        menus: [],
      },
      {
        menuId: 33,
        status: 1,
        parentId: 5,
        menuName: '运营位配置',
        menus: [
          {
            menuId: 34,
            status: 1,
            parentId: 33,
            menuName: 'banner管理',
            menus: [],
          },
        ],
      },
      {
        menuId: 31,
        status: 1,
        parentId: 5,
        menuName: '公告管理',
        menus: [],
      },
      {
        menuId: 28,
        status: 1,
        parentId: 5,
        menuName: '帮助中心管理',
        menus: [],
      },
      {
        menuId: 7,
        status: 1,
        parentId: 5,
        menuName: '流程配置',
        menus: [],
      },
      {
        menuId: 6,
        status: 1,
        parentId: 5,
        menuName: '权限管理',
        menus: [
          {
            menuId: 9,
            status: 1,
            parentId: 6,
            menuName: '人员管理',
            menus: [],
          },
          {
            menuId: 8,
            status: 1,
            parentId: 6,
            menuName: '角色组管理',
            menus: [],
          },
        ],
      },
      {
        menuId: 82,
        status: 1,
        parentId: 5,
        menuName: '员工端重要通知',
        menus: [],
      },
      {
        menuId: 84,
        status: 1,
        parentId: 5,
        menuName: 'C店类目负责人配置',
        menus: [],
      },
      {
        menuId: 85,
        status: 1,
        parentId: 5,
        menuName: '流量场类目管理',
        menus: [],
      },
      {
        menuId: 90,
        status: 1,
        parentId: 5,
        menuName: '屏蔽策略配置',
        menus: [],
      },
    ],
  },
  {
    menuId: 4,
    status: 1,
    parentId: -1,
    menuName: '数据中心',
    menus: [
      {
        menuId: 67,
        status: 1,
        parentId: 4,
        menuName: '活动效果数据',
        menus: [],
      },
      {
        menuId: 64,
        status: 1,
        parentId: 4,
        menuName: '提报运营数据',
        menus: [],
      },
      {
        menuId: 61,
        status: 1,
        parentId: 4,
        menuName: '会场流程数据',
        menus: [],
      },
      {
        menuId: 60,
        status: 1,
        parentId: 4,
        menuName: '用户资产沉淀',
        menus: [],
      },
      {
        menuId: 52,
        status: 1,
        parentId: 4,
        menuName: '活动进度监控',
        menus: [],
      },
      {
        menuId: 27,
        status: 1,
        parentId: 4,
        menuName: '资源位数据',
        menus: [],
      },
      {
        menuId: 15,
        status: 1,
        parentId: 4,
        menuName: '活动对比',
        menus: [
          {
            menuId: 20,
            status: 1,
            parentId: 15,
            menuName: '数据对比',
            menus: [],
          },
          {
            menuId: 19,
            status: 1,
            parentId: 15,
            menuName: '活动选择',
            menus: [],
          },
        ],
      },
      {
        menuId: 73,
        status: 1,
        parentId: 4,
        menuName: '商品池全链路度量体系',
        menus: [],
      },
      {
        menuId: 71,
        status: 1,
        parentId: 4,
        menuName: '频道四化看板',
        menus: [],
      },
      {
        menuId: 76,
        status: 1,
        parentId: 4,
        menuName: '业务经营体系看板',
        menus: [],
      },
      {
        menuId: 77,
        status: 1,
        parentId: 4,
        menuName: '活动参与效果',
        menus: [],
      },
      {
        menuId: 78,
        status: 1,
        parentId: 4,
        menuName: '综促进度监控',
        menus: [],
      },
      {
        menuId: 86,
        status: 1,
        parentId: 4,
        menuName: '货盘数据看板',
        menus: [],
      },
    ],
  },
  {
    menuId: 3,
    status: 1,
    parentId: -1,
    menuName: '平台资源',
    menus: [
      {
        menuId: 37,
        status: 1,
        parentId: 3,
        menuName: '活动数据',
        menus: [],
      },
      {
        menuId: 36,
        status: 1,
        parentId: 3,
        menuName: '申请列表',
        menus: [],
      },
      {
        menuId: 24,
        status: 1,
        parentId: 3,
        menuName: '资源位列表',
        menus: [],
      },
      {
        menuId: 23,
        status: 1,
        parentId: 3,
        menuName: '资源列表',
        menus: [],
      },
      {
        menuId: 13,
        status: 1,
        parentId: 3,
        menuName: '资源调剂',
        menus: [],
      },
      {
        menuId: 12,
        status: 1,
        parentId: 3,
        menuName: '申请管理',
        menus: [],
      },
      {
        menuId: 2,
        status: 1,
        parentId: 3,
        menuName: '资源广场',
        menus: [],
      },
      {
        menuId: 1,
        status: 1,
        parentId: 3,
        menuName: '活动广场',
        menus: [],
      },
    ],
  },
  {
    menuId: 2,
    status: 1,
    parentId: 3,
    menuName: '资源广场',
    menus: [],
  },
  {
    menuId: 1,
    status: 1,
    parentId: 3,
    menuName: '活动广场',
    menus: [],
  },
  {
    menuId: 73,
    status: 1,
    parentId: 4,
    menuName: '商品池全链路度量体系',
    menus: [],
  },
  {
    menuId: 71,
    status: 1,
    parentId: 4,
    menuName: '频道四化看板',
    menus: [],
  },
  {
    menuId: 75,
    status: 1,
    parentId: 57,
    menuName: '活动报名',
    menus: [],
  },
  {
    menuId: 76,
    status: 1,
    parentId: 4,
    menuName: '业务经营体系看板',
    menus: [],
  },
  {
    menuId: 77,
    status: 1,
    parentId: 4,
    menuName: '活动参与效果',
    menus: [],
  },
  {
    menuId: 79,
    status: 1,
    parentId: 46,
    menuName: '趋势数据',
    menus: [],
  },
  {
    menuId: 78,
    status: 1,
    parentId: 4,
    menuName: '综促进度监控',
    menus: [],
  },
  {
    menuId: 80,
    status: 1,
    parentId: 46,
    menuName: '热点营销',
    menus: [],
  },
  {
    menuId: 82,
    status: 1,
    parentId: 5,
    menuName: '员工端重要通知',
    menus: [],
  },
  {
    menuId: 81,
    status: 1,
    parentId: 46,
    menuName: '营销词洞察',
    menus: [],
  },
  {
    menuId: 84,
    status: 1,
    parentId: 5,
    menuName: 'C店类目负责人配置',
    menus: [],
  },
  {
    menuId: 85,
    status: 1,
    parentId: 5,
    menuName: '流量场类目管理',
    menus: [],
  },
  {
    menuId: 86,
    status: 1,
    parentId: 4,
    menuName: '货盘数据看板',
    menus: [],
  },
  {
    menuId: 90,
    status: 1,
    parentId: 5,
    menuName: '屏蔽策略配置',
    menus: [],
  },
  {
    menuId: 91,
    status: 1,
    parentId: -1,
    menuName: '货主阵地',
    menus: [
      {
        menuId: 92,
        status: 1,
        parentId: 91,
        menuName: '货品监控',
        menus: [],
      },
    ],
  },
  {
    menuId: 92,
    status: 1,
    parentId: 91,
    menuName: '货品监控',
    menus: [],
  },
];

// let menu_obj = {};

// const flapMenus = (menus) => {
//   menus.map((item) => {
//     menu_obj[item.menuId] = item;
//     if (item.menus?.length) {
//       flapMenus(item.menus);
//     }
//   });
// };

// flapMenus(menus);

const res = {};
function mapmenus(menus, key = []) {
  if (!menus.length) return;

  for (var i = 0; i < menus.length; i++) {
    var menu = menus[i];
    if (key.length) res[menu.menuId] = key.slice();
    key.push(menu.menuId);
    mapmenus(menu.menus, key);
    key.pop(menu.menuId);
  }
}

mapmenus(menus);

// function findParentIdList(id) {
//   let parentIds = [];
//   findParentId(id);
//   function findParentId(id) {
//     if (menu_obj[id] && menu_obj[id].parentId !== -1) {
//       parentIds.push(menu_obj[id].parentId);
//       findParentId(menu_obj[id].parentId);
//     }
//     return;
//   }
//   return parentIds;
// }

const aaa = [
  {
    menuId: 68,
    menuName: '营销能力矩阵',
    menus: [],
  },
  {
    menuId: 67,
    menuName: '活动效果数据',
    menus: [],
  },
  {
    menuId: 66,
    menuName: '工具箱',
    menus: [],
  },
  {
    menuId: 65,
    menuName: '平台营销阵地',
    menus: [],
  },
  {
    menuId: 64,
    menuName: '提报运营数据',
    menus: [],
  },
  {
    menuId: 63,
    menuName: '频道管理',
    menus: [],
  },
  {
    menuId: 62,
    menuName: '白名单管理',
    menus: [],
  },
  {
    menuId: 61,
    menuName: '会场流程数据',
    menus: [],
  },
  {
    menuId: 60,
    menuName: '用户资产沉淀',
    menus: [],
  },
  {
    menuId: 59,
    menuName: '已报名素材',
    menus: [],
  },
  {
    menuId: 58,
    menuName: '待审核管理',
    menus: [],
  },
  {
    menuId: 57,
    menuName: '待办事项',
    menus: [],
  },
  {
    menuId: 56,
    menuName: '盘货活动',
    menus: [],
  },
  {
    menuId: 55,
    menuName: '综合促销',
    menus: [],
  },
  {
    menuId: 54,
    menuName: '会场活动',
    menus: [],
  },
  {
    menuId: 53,
    menuName: '日常活动',
    menus: [],
  },
  {
    menuId: 52,
    menuName: '活动进度监控',
    menus: [],
  },
  {
    menuId: 51,
    menuName: '权限管理',
    menus: [],
  },
  {
    menuId: 49,
    menuName: '趋势管理',
    menus: [],
  },
  {
    menuId: 48,
    menuName: '满意度调研配置',
    menus: [],
  },
  {
    menuId: 47,
    menuName: '营销TREE配置',
    menus: [],
  },
  {
    menuId: 46,
    menuName: '营销词阵地',
    menus: [],
  },
  {
    menuId: 45,
    menuName: '资源位管理',
    menus: [],
  },
  {
    menuId: 44,
    menuName: '商家阵地管理',
    menus: [],
  },
  {
    menuId: 43,
    menuName: '自动化素材',
    menus: [],
  },
  {
    menuId: 42,
    menuName: '潘多拉',
    menus: [],
  },
  {
    menuId: 41,
    menuName: '广告组',
    menus: [],
  },
  {
    menuId: 40,
    menuName: '商品组',
    menus: [],
  },
  {
    menuId: 39,
    menuName: '素材管理',
    menus: [],
  },
  {
    menuId: 38,
    menuName: '商家端帮助中心',
    menus: [],
  },
  {
    menuId: 37,
    menuName: '活动数据',
    menus: [],
  },
  {
    menuId: 36,
    menuName: '申请列表',
    menus: [],
  },
  {
    menuId: 35,
    menuName: '行业频道',
    menus: [],
  },
  {
    menuId: 34,
    menuName: 'banner管理',
    menus: [],
  },
  {
    menuId: 33,
    menuName: '运营位配置',
    menus: [],
  },
  {
    menuId: 32,
    menuName: '分析报告',
    menus: [],
  },
  {
    menuId: 31,
    menuName: '公告管理',
    menus: [],
  },
  {
    menuId: 29,
    menuName: '日常活动',
    menus: [],
  },
  {
    menuId: 28,
    menuName: '帮助中心管理',
    menus: [],
  },
  {
    menuId: 27,
    menuName: '资源位数据',
    menus: [],
  },
  {
    menuId: 25,
    menuName: '工作台',
    menus: [],
  },
  {
    menuId: 24,
    menuName: '资源位列表',
    menus: [],
  },
  {
    menuId: 23,
    menuName: '资源列表',
    menus: [],
  },
  {
    menuId: 20,
    menuName: '数据对比',
    menus: [],
  },
  {
    menuId: 19,
    menuName: '活动选择',
    menus: [],
  },
  {
    menuId: 18,
    menuName: '用户画像',
    menus: [],
  },
  {
    menuId: 17,
    menuName: '商品效果',
    menus: [],
  },
  {
    menuId: 16,
    menuName: '活动数据',
    menus: [],
  },
  {
    menuId: 15,
    menuName: '活动对比',
    menus: [],
  },
  {
    menuId: 12,
    menuName: '申请管理',
    menus: [],
  },
  {
    menuId: 11,
    menuName: '主题活动',
    menus: [],
  },
  {
    menuId: 10,
    menuName: '活动管理',
    menus: [],
  },
  {
    menuId: 9,
    menuName: '人员管理',
    menus: [],
  },
  {
    menuId: 8,
    menuName: '角色组管理',
    menus: [],
  },
  {
    menuId: 7,
    menuName: '流程配置',
    menus: [],
  },
  {
    menuId: 6,
    menuName: '权限管理',
    menus: [],
  },
  {
    menuId: 5,
    menuName: '系统设置',
    menus: [],
  },
  {
    menuId: 4,
    menuName: '数据中心',
    menus: [],
  },
  {
    menuId: 3,
    menuName: '平台资源',
    menus: [],
  },
  {
    menuId: 2,
    menuName: '资源广场',
    menus: [],
  },
  {
    menuId: -31,
    menus: [],
  },
  {
    menuId: 72,
    menuName: '菜单72',
    menus: [],
  },
  {
    menuId: 73,
    menuName: '商品池度量',
    menus: [],
  },
  {
    menuId: 74,
    menuName: '频道四化看板',
    menus: [],
  },
  {
    menuId: 75,
    menuName: '活动报名',
    menus: [],
  },
  {
    menuId: 76,
    menuName: '业务经营体系',
    menus: [],
  },
  {
    menuId: 77,
    menuName: '我参与的',
    menus: [],
  },
  {
    menuId: 78,
    menuName: '综促进度监控',
    menus: [],
  },
  {
    menuId: 79,
    menuName: '趋势数据',
    menus: [],
  },
  {
    menuId: 80,
    menuName: '热点营销',
    menus: [],
  },
  {
    menuId: 1100,
    menuName: '1100',
    menus: [],
  },
  {
    menuId: 81,
    menuName: '营销词洞察',
    menus: [],
  },
  {
    menuId: 82,
    menuName: '员工端重要通知',
    menus: [],
  },
  {
    menuId: 1000011,
    menuName: '1000011',
    menus: [],
  },
  {
    menuId: 84,
    menuName: 'C店类目负责人配置',
    menus: [],
  },
  {
    menuId: 85,
    menuName: '流量场类目管理',
    menus: [],
  },
  {
    menuId: 86,
    menuName: '货盘数据看板',
    menus: [],
  },
  {
    menuId: 1001,
    menuName: '首页',
    menus: [],
  },
  {
    menuId: 1002,
    menuName: '用户管理',
    menus: [],
  },
  {
    menuId: 1003,
    menuName: '应用管理',
    menus: [],
  },
  {
    menuId: 1004,
    menuName: '系统设置',
    menus: [],
  },
  {
    menuId: 1005,
    menuName: '监控管理',
    menus: [],
  },
  {
    menuId: 1006,
    menuName: '阵地菜单',
    menus: [],
  },
  {
    menuId: 1007,
    menuName: '日志追踪',
    menus: [],
  },
  {
    menuId: 1008,
    menuName: '数据字典',
    menus: [],
  },
  {
    menuId: 1009,
    menuName: '长任务管理',
    menus: [],
  },
  {
    menuId: 1010,
    menuName: '反馈设置',
    menus: [],
  },
  {
    menuId: 1011,
    menuName: 'ERP透视',
    menus: [],
  },
  {
    menuId: 1012,
    menuName: '权限管理',
    menus: [],
  },
  {
    menuId: 1013,
    menuName: '接口监控',
    menus: [],
  },
  {
    menuId: 1014,
    menuName: '权限配置',
    menus: [],
  },
  {
    menuId: 90,
    menuName: '屏蔽策略配置',
    menus: [],
  },
  {
    menuId: 91,
    menuName: '货主阵地',
    menus: [],
  },
  {
    menuId: 92,
    menuName: '货品监控',
    menus: [],
  },
  {
    menuId: 93,
    menuName: '场域控制',
    menus: [],
  },
  {
    menuId: 94,
    menuName: '货品运营',
    menus: [],
  },
  {
    menuId: 95,
    menuName: '流量运营',
    menus: [],
  },
  {
    menuId: 117,
    menuName: '黄流运营（场主版）',
    menus: [],
  },
  {
    menuId: 117,
    menuName: '黄流运营（货主版）',
    menus: [],
  },
  {
    menuId: 98,
    menuName: '推荐运营',
    menus: [],
  },
  {
    menuId: 99,
    menuName: '搜推运营',
    menus: [],
  },
  {
    menuId: 100,
    menuName: '用户运营',
    menus: [],
  },
  {
    menuId: 101,
    menuName: '营销工具',
    menus: [],
  },
  {
    menuId: 102,
    menuName: '选品工具',
    menus: [],
  },
  {
    menuId: 103,
    menuName: '通天塔',
    menus: [],
  },
  {
    menuId: 104,
    menuName: '素材管理工具',
    menus: [],
  },
  {
    menuId: 105,
    menuName: '设计工具',
    menus: [],
  },
  {
    menuId: 106,
    menuName: '优惠券创建',
    menus: [],
  },
  {
    menuId: 107,
    menuName: '标签平台',
    menus: [],
  },
  {
    menuId: 108,
    menuName: '京准通运营后台',
    menus: [],
  },
];

export function findParentItemsList(aaa) {
  let arr = [];
  aaa.map((item) => {
    // arr = arr.concat(findParentIdList(item.menuId));
    if (res[item.menuId]) arr = arr.concat(res[item.menuId]);
  });
  return uniq(arr).map((ele) => {
    return { menuId: ele, menus: [] };
  });
}

// console.log(findParentItemsList(aaa));
